/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {
  TableDefault,
  ShadowTableHead,
  StickyMainHeader,
  StickyShadowMainHeader,
  StickySubHeader,
  ArrowHolderSummary,
  ColumnContainerSummary,
  TeamAverageRow,
  ShadowSummaryColumn,
  ArrowDownContainer,
  DownloadButton,
  ShadowTableColumn,
} from './styles';
import {Utils} from '../../utils/api';
import {GoChevronDown, GoChevronUp, GoArrowDown} from 'react-icons/go';
import numberColumnFormatter from '../../utils/hooks/number-column-formatter';
import getFatigueZoneBullet from '../../utils/hooks/fatigue-zone-bullet';
import HideOn from '../../assets/icons/HideOn.png';
import HideOff from '../../assets/icons/HideOff.png';
import Loader from '../loader/loader';
import {Admin} from '../../utils/api';
import getAlertZoneBullet from '../../utils/hooks/trend-zone-bullet';

export default ({
  dataTableContent,
  average,
  dataCy,
  fatigueZone,
  setTableUpdated,
  hideExam,
}: {
  dataTableContent: Array<any>;
  average: any;
  dataCy?: string;
  fatigueZone?: boolean;
  setTableUpdated?: any;
  hideExam?: any;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const [loading, useLoading] = useState<boolean>(false);
  const ADMIN = new Admin();
  const UTILS = new Utils();

  useEffect(() => {
    useTable(dataTableContent);
    useLoading(false);
  }, [dataTableContent]);

  useEffect(() => {
    if (loading) {
      setTableUpdated(true);
    }
  }, [loading]);

  function changeTable(e) {
    useTable([...e]);
  }
  function toggleSortDate(sort, params) {
    const sortOptions = [!reverse, changeTable, table];
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortIsoDate(params, sortOptions);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }
  function toggleSortNumber(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.HandleSorted(params, sortOptions);
  }
  function changeStatus(change) {
    // if (change < 0) {
    //   return (
    //     <ArrowDownContainer>
    //       <GoArrowDown size="10px" color="#fff" />
    //     </ArrowDownContainer>
    //   );
    // }
    return null;
  }

  function SortingTableHead({title = '', attr, location, sortFunction}) {
    return (
      <StickySubHeader onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </StickySubHeader>
    );
  }
  function SortingShadowTableHead({title = '', attr, location, sortFunction}) {
    return (
      <ShadowTableHead onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </ShadowTableHead>
    );
  }

  async function DownloadReport(examId, type, firstname, lastname, date) {
    if (!type) {
      type = 'Fresh';
    }
    ADMIN.GetPlayerExamById(examId, firstname, `${type}_` + lastname, date);
  }

  return (
    <TableDefault data-cy={dataCy} minWidth="1200px">
      <thead>
        <tr>
          <StickyMainHeader colSpan={1}>HIDE</StickyMainHeader>
          <StickyMainHeader colSpan={1}>DATE</StickyMainHeader>
          <StickyMainHeader colSpan={1}>EXAM TYPE</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>TOTAL STRENGTH</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>INTERNAL ROTATION</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>EXTERNAL ROTATION</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>ER : IR RATIO</StickyMainHeader>
          <StickyShadowMainHeader colSpan={2}>SCAPTION</StickyShadowMainHeader>
          <StickyMainHeader colSpan={2}>GRIP</StickyMainHeader>
          <StickyShadowMainHeader colSpan={1}>REPORT</StickyShadowMainHeader>
        </tr>
        <tr>
          <StickySubHeader />
          <SortingTableHead title="Sort date" attr="date" location={['createdAt']} sortFunction={toggleSortDate} />
          <SortingTableHead title="Sort Type" attr="type" location={['type']} sortFunction={toggleSortString} />
          <SortingShadowTableHead
            title="Result"
            attr="tcurrent"
            location={['strength', 'totalCurrent']}
            sortFunction={toggleSortNumber}
          />
          <SortingShadowTableHead title="Change" attr="tchange" location={['strength', 'totalChange']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Result" attr="ircurrent" location={['strength', 'irCurrent']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Change" attr="irchange" location={['strength', 'irChange']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Result" attr="ercurrent" location={['strength', 'erCurrent']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead title="Change" attr="erchange" location={['strength', 'erChange']} sortFunction={toggleSortNumber} />
          <SortingTableHead
            title="Result"
            attr="erircurrent"
            location={['strength', 'erirRatioCurrent']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="Change" attr="erirchange" location={['strength', 'erirRatioChange']} sortFunction={toggleSortNumber} />
          <SortingShadowTableHead
            title="Result"
            attr="scurrent"
            location={['strength', 'scaptionCurrent']}
            sortFunction={toggleSortNumber}
          />
          <SortingShadowTableHead
            title="Change"
            attr="schange"
            location={['strength', 'scaptionChange']}
            sortFunction={toggleSortNumber}
          />
          <SortingTableHead title="Result" attr="gcurrent" location={['strength', 'gripCurrent']} sortFunction={toggleSortNumber} />
          <SortingTableHead title="Change" attr="gchange" location={['strength', 'gripChange']} sortFunction={toggleSortNumber} />
          <ShadowTableHead />
        </tr>
      </thead>
      <tbody onClick={() => useSort('')}>
        {table.length > 0 && (
          <TeamAverageRow>
            <td>Avg</td>
            <td>{loading && <Loader width="20px" color="#B1D6FF" />}</td>
            <td />
            <ShadowSummaryColumn>{numberColumnFormatter(average?.avgStrengthCurrent, {digits: 1})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(average?.avgStrengthChange, {digits: 1})}
              {changeStatus(average?.avgStrengthChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(average?.avgIRCurrent, {digits: 1})}</td>
            <td>
              {numberColumnFormatter(average?.avgIRChange, {digits: 1})}
              {changeStatus(average?.avgIRChange)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(average?.avgERCurrent, {digits: 1})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(average?.avgERChange, {digits: 1})}
              {changeStatus(average?.avgERChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(average?.avgERIRRatioCurrent, {digits: 2})}</td>
            <td>
              {numberColumnFormatter(average?.avgERIRRatioChange, {digits: 2})}
              {changeStatus(average?.avgERIRRatioChange)}
            </td>
            <ShadowSummaryColumn>{numberColumnFormatter(average?.avgScaptionCurrent, {digits: 1})}</ShadowSummaryColumn>
            <ShadowSummaryColumn>
              {numberColumnFormatter(average?.avgScaptionChange, {digits: 1})}
              {changeStatus(average?.avgScaptionChange)}
            </ShadowSummaryColumn>
            <td>{numberColumnFormatter(average?.avgGripCurrent, {digits: 1})}</td>
            <td>
              {numberColumnFormatter(average?.avgGripChange, {digits: 1})}
              {changeStatus(average?.avgGripChange)}
            </td>
            <ShadowSummaryColumn />
          </TeamAverageRow>
        )}
        {table.length > 0 ? (
          table.map(item => {
            return (
              <TableItem
                key={item._id}
                item={item}
                useLoading={useLoading}
                fatigueZone={fatigueZone}
                changeStatus={changeStatus}
                DownloadReport={DownloadReport}
                hideExam={hideExam}
              />
            );
          })
        ) : (
          <tr>
            <td colSpan={25}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableDefault>
  );
};

const TableItem = ({item, useLoading, fatigueZone, changeStatus, DownloadReport, hideExam}) => {
  const [hide, setHide] = useState<Boolean>(item.excludeFromExamAvg);
  const [opacity, setOpacity] = useState<string>(item.excludeFromExamAvg ? '0.5' : '1');

  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    hide ? setOpacity('0.5') : setOpacity('1');
    hideExam(item._id, hide, 'fresh');
    useLoading(true);
  }, [hide]);

  function handleDate(date) {
    return date ? new Date(date).toLocaleDateString('en-US') : '-';
  }

  return (
    <tr style={{opacity: opacity}}>
      <td className="white pointer" onClick={() => setHide(!hide)}>
        {hide ? <img src={HideOn} alt="hideOn" /> : <img src={HideOff} alt="hideOn" />}
      </td>
      <td className="white">{handleDate(item?.createdAt)}</td>
      <td className="white">{item?.type}</td>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.totalCurrent)}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.totalStatus)}
        {fatigueZone && getAlertZoneBullet(item?.strength, item?.strength?.totalStatusTrend, item?.strength?.totalStatus)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.totalChange)}
        {changeStatus(item?.strength?.totalChange)}
      </ShadowTableColumn>
      <td className="white" style={{position: 'relative'}}>
        {numberColumnFormatter(item?.strength?.irCurrent)}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.irStatus)}
        {fatigueZone && getAlertZoneBullet(item?.strength, item?.strength?.irStatusTrend, item?.strength?.irStatus)}
      </td>
      <td className="white">
        {numberColumnFormatter(item?.strength?.irChange)}
        {changeStatus(item?.strength?.irChange)}
      </td>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.erCurrent)}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.erStatus)}
        {fatigueZone && getAlertZoneBullet(item?.strength, item?.strength?.erStatusTrend, item?.strength?.erStatus)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.erChange)}
        {changeStatus(item?.strength?.erChange)}
      </ShadowTableColumn>
      <td className="white">
        {numberColumnFormatter(item?.strength?.erirRatioCurrent, {digits: 2})}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.erirRatioStatus)}
      </td>
      <td className="white">
        {numberColumnFormatter(item?.strength?.erirRatioChange, {digits: 2})}
        {changeStatus(item?.strength?.erirRatioChange)}
      </td>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.scaptionCurrent)}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.scaptionStatus)}
        {fatigueZone && getAlertZoneBullet(item?.strength, item?.strength?.scaptionStatusTrend, item?.strength?.scaptionStatus)}
      </ShadowTableColumn>
      <ShadowTableColumn>
        {numberColumnFormatter(item?.strength?.scaptionChange)}
        {changeStatus(item?.strength?.scaptionChange)}
      </ShadowTableColumn>
      <td className="white" style={{position: 'relative'}}>
        {numberColumnFormatter(item?.strength?.gripCurrent)}
        {fatigueZone && getFatigueZoneBullet(item?.strength?.gripStatus)}
        {fatigueZone && getAlertZoneBullet(item?.strength, item?.strength?.gripStatusTrend, item?.strength?.gripStatus)}
      </td>
      <td className="white">
        {numberColumnFormatter(item?.strength?.gripChange)}
        {changeStatus(item?.strength?.gripChange)}
      </td>
      <ShadowTableColumn>
        {item?.enabledPDF && (
          <DownloadButton
            type="PDF"
            onClick={() => !hide && DownloadReport(item?._id, item?.type, item?.firstName, item?.lastName, item?.createdAt)}>
            ↓ PDF
          </DownloadButton>
        )}
      </ShadowTableColumn>
    </tr>
  );
};
